<app-progress [totalPage]="4" [pageIndex]="4"></app-progress>
<ion-content>
  <div class="margin-common">
    <ion-row class="margin-top-1">
      <ion-col class="text-center ion-align-self-center">
        <h2 class="heading">Please share us your name</h2>
      </ion-col>
    </ion-row>
    <!-- <ion-row>
      <ion-col class="text-center ion-align-self-center">
        <p class="small-text">- CHOOSE MAX 03 OPTION -</p>
      </ion-col>
    </ion-row> -->

    <ion-row>
      <ion-col class="text-center ion-align-self-center">
        <!-- <img class="img-quest" src="./assets/icons/Group 167.svg" /> -->
        <img class="img-quest width-80" src="./assets/icons/user-details.png" />
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="text-center">
        <ion-item>
          <ion-label position="fixed">Name: </ion-label>
          <ion-input type="text" placeholder="Enter name" (ionChange)="chageName($event)"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>

    <!-- <ion-row>
      <ion-col class="text-center">
        <ion-item>
          <ion-label position="fixed">Last Name: </ion-label>
          <ion-input type="text" placeholder="Enter Last name" (ionChange)="chageLastName($event)"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row> -->
    <!-- <ion-item>
      <ion-label position="fixed">First Name: </ion-label>
      <ion-input type="text" [(ngModel)]="firstName"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label position="fixed">Last Name: </ion-label>
      <ion-input type="text" [(ngModel)]="lastName"></ion-input>
    </ion-item> -->
    <br />
  </div>
</ion-content>

<ion-footer class="btn">
  <ion-toolbar class="white-footer">
    <!-- <div class="width-50" slot="start">
      <ion-button
        mode="ios"
        class="button button-cancel button-full"
        shape="round"
        (click)="cancel()"
      >
        {{'button.back' |translate}}
      </ion-button>
    </div> -->
    <!-- <ion-title></ion-title> -->
    <div class="width-100">
      <ion-button
        mode="ios"
        class="button button-dander button-full"
        shape="round"
        fill="outline"
       [disabled]="name == ''"
       (click)="doUpdateValue()"
      >
        {{'button.next' |translate}}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
